import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import user from "./user.module";
import iot from "./iot.module";
import mangrove_location from "./mangrove_location.module";
import pin_infomation from "./pin_infomation.module";
import more_detail_info from "./more_detail_info.module";
import points_could from "./points_could.module";
import points_could_different from "./points_could_different.module";
import points_could_original from "./points_could_original.module";
import mangroveInfo from "./mangroveInfo.module";
import userType from "./userType.module";
import videoStream from "./videoStream.module";
import gallery from "./gallery.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    user,
    userType,
    iot,
    mangroveInfo,
    mangrove_location,
    pin_infomation,
    videoStream,
    more_detail_info,
    points_could,
    points_could_original,
    points_could_different,
    gallery
  }
});